import { render, staticRenderFns } from "./ResultMaterialsComputation.vue?vue&type=template&id=af367a8c&scoped=true&"
import script from "./ResultMaterialsComputation.vue?vue&type=script&lang=js&"
export * from "./ResultMaterialsComputation.vue?vue&type=script&lang=js&"
import style0 from "./ResultMaterialsComputation.vue?vue&type=style&index=0&id=af367a8c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af367a8c",
  null
  
)

export default component.exports